//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import uniIcons from "@/components/uni-icon/uni-icon.vue"
import uniLoadMore from "components/uni-load-more/uni-load-more.vue"
export default {
	data(){
		return{
			show:true,
			loading:false,
			contentText:{
				contentrefresh: "正在上传..."
			}
		}
	},
	components:{
		// uniIcons,
		uniLoadMore
	},
	props:{
		imageList:{
			type:Array,
			default:function(){
				return []
			}
		},
		length:{
			type:Number,
			default:9
		}
	},
	watch:{
		imageList(val,newVal){
			if(newVal.length>=this.length){
				this.show=false
			} else {
				this.show=true
			}
		}
	},
	methods:{
		remove(i){
			this.$emit('remove',i)
		},
		addImage(){
			let _this=this
			uni.chooseImage({
			count: _this.length, //默认9
			sizeType: ['compressed'], //可以指定是原图还是压缩图，默认二者都有
			sourceType: ['album'], //从相册选择
			success: function (res) {
				// _this.lodalImages.push(res.tempFilePaths)
				let pics=[]
				if(res.tempFiles.length+_this.imageList.length>_this.length){
					uni.showToast({
						title:`最多上传${_this.length}张`,
						icon:'none'
					})
					return false
				}
				for (let i = 0; i < res.tempFilePaths.length; i++) {
					pics.push(res.tempFilePaths[i])
				}
				_this.upImage(pics)
			}
		})
		},
		async upImage(files){
			for(let i=0;i<files.length;i++){
				await this.upServer(files[i])
			}
		},
		upServer(file){
			let _this=this
			_this.loading=true
			uni.uploadFile({
				url: _this.$store.state.proxyUrl+'/weChat/file/upload', //仅为示例，非真实的接口地址
				filePath: file,
				formData: {
					'tenantId': _this.$store.state.tenantId
				},
				name: 'files',
				success: (uploadFileRes) => {
					let url=JSON.parse(uploadFileRes.data).data[0].store
					_this.loading=false
					_this.$emit('addImage',url)
				}
			})
		}
	}
}
